import type { UserModel } from '@/domain/models/user.js';

export function resolveCanManageUsers(me: UserModel | null | undefined): boolean {
    return me?.isGlobalAdmin || me?.profile === 'PMO';
}
